import React from "react";
// import { coinState } from "../../../App"; 
import { useTranslation } from "react-i18next";
import { lang } from "../../../lang";

const TokenwarnPopup = (props) => {
  // const ref = useRef(null);

  const setTokenwarn = props?.setTokenwarn
  // const setPermission = props?.setPermission
  const handleOK = props?.handleOK
  const setSingleScreenButton = props?.setSingleScreenButton


  const {t} = useTranslation();
  return (
    <div className="blur-screen-full-area inner-modal flex-center">
      <div className="form-container d-flex flex-column align-items-center my-2">
        {/* <h3 className="text-bold text-center fs-3 mb-3">Success</h3> */}
        <div className="text-center m-3">{props?.message}</div>
        <div className=" flex-center">
          <button
            type="submit"
            className="theme-btn px-5 text-center w-70 mx-2"
            style={{  }}
            onClick={()=>{
              setTokenwarn(false)
              // setPermission(true)
              handleOK()
              setSingleScreenButton && setSingleScreenButton()
              // props?.setUpdateOnUnlock(!props?.updateOnUnlock) 
            }}
          >
            {t('Ok')}
          </button>
           <button
            type="submit"
            className="theme-btn px-5 text-center w-70 "
            style={{  }}
            onClick={()=>{
              setTokenwarn(false)
            }}
          >
            {t('Not Now')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenwarnPopup;
